import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath(
  "https://www.gstatic.com/draco/versioned/decoders/1.5.6/"
);

function loadModelWithDRACO(modelPath) {
  const loader = new GLTFLoader();
  loader.setDRACOLoader(dracoLoader);

  return new Promise((resolve, reject) => {
    loader.load(modelPath, resolve, undefined, reject);
  });
}

async function loadModel(options) {
  const {
    scene,
    childName,
    modelPath,
    modelMaterial,
    position = { x: 0, y: 0, z: 0 },
  } = options;

  try {
    const gltf = await loadModelWithDRACO(modelPath);

    gltf.scene.traverse((child) => {
      if (child.isMesh) {
        child.name = childName;
        child.material = modelMaterial;
        child.castShadow = true;
        child.receiveShadow = true;
        child.frustumCulled = true;
      }
    });

    gltf.scene.position.set(position.x, position.y, position.z);
    scene.add(gltf.scene);
  } catch (error) {
    console.error("Error loading model:", error);
  }
}

// async function loadUVModel(options) {
//   const {
//     scene,
//     childName,
//     modelPath,
//     map,
//     enviromentMap,
//     isUVAnimated = false,
//     position = { x: 0, y: 0, z: 0 },
//   } = options;

//   try {
//     const gltf = await loadModelWithDRACO(modelPath);

//     gltf.scene.traverse((child) => {
//       if (child.isMesh) {
//         child.name = childName;
//         child.material.color = new THREE.Color(0xe3e6c8);
//         child.material.roughness = 1;
//         child.material.metalness = 1;
//         child.material.map = map;
//         child.material.emissive = new THREE.Color(0x000000);
//         child.material.envMap = enviromentMap.texture;
//         child.material.envMapIntensity = 5;
//         child.frustumCulled = true;
//         child.isUVAnimated = isUVAnimated;
//       }
//     });

//     gltf.scene.position.set(position.x, position.y, position.z);
//     scene.add(gltf.scene);
//   } catch (error) {
//     console.error("Error loading model:", error);
//   }
// }

async function loadUVModel(options) {
  const {
    scene,
    childName,
    modelPath,
    map,
    isUVAnimated = false,
    position = { x: 0, y: 0, z: 0 },
  } = options;

  try {
    const gltf = await loadModelWithDRACO(modelPath);

    gltf.scene.traverse((child) => {
      if (child.isMesh) {
        const material = new THREE.MeshBasicMaterial({
          map: map,
          color: new THREE.Color(0xffffff),
          side: THREE.BackSide,
        });

        child.material = material;
        child.name = childName;
        child.frustumCulled = true;
        child.isUVAnimated = isUVAnimated;
        child.visible = true;
      }
    });

    gltf.scene.position.set(position.x, position.y, position.z);
    scene.add(gltf.scene);
  } catch (error) {
    console.error("Error loading model:", error);
  }
}

function animateUVMap(options) {
  const { scene, speedUV = 0.0005 } = options;

  scene.traverse((child) => {
    if (child.isMesh && child.isUVAnimated) {
      const uvAttribute = child.geometry.attributes.uv;
      if (uvAttribute) {
        for (let i = 0; i < uvAttribute.count; i++) {
          uvAttribute.setX(i, uvAttribute.getX(i) + speedUV);
        }
        uvAttribute.needsUpdate = true;
      }
    }
  });
}

export { loadModel, loadUVModel, animateUVMap };
